import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  :root {
    --brand-bg: ${({ theme }) => theme.body};
    --brand-surface: ${({ theme }) => theme.surface};
    --brand-gold: ${({ theme }) => theme.gold};
    --brand-gold-dark: ${({ theme }) => theme.goldDark};
    --brand-text: ${({ theme }) => theme.text};
    --brand-muted: ${({ theme }) => theme.secondaryText};
    --brand-border: ${({ theme }) => theme.border};
    --brand-dark: ${({ theme }) => theme.dark};
    color-scheme: ${({ theme }) => theme.mode};
  }

  html {
    overflow-y: scroll;
    overflow-x: clip;
    scrollbar-gutter: stable;
  }

  *,
  *::after,
  *::before {
    box-sizing: border-box;
  }

  body {
    overflow-x: clip;
    align-items: center;
    background:
      radial-gradient(circle at 12% -10%, ${({ theme }) =>
        theme.glowPrimary}, transparent 34rem),
      radial-gradient(circle at 92% 12%, ${({ theme }) =>
        theme.glowSecondary}, transparent 28rem),
      ${({ theme }) => theme.body};
    background-attachment: fixed;
    color: ${({ theme }) => theme.text};
    display: flex;
    // flex-direction: column;
    // justify-content: center;
    // height: 100vh;
    // margin: 0;
    // padding: 0;
    font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    transition: background-color 0.25s linear, color 0.25s linear;
  }

  #root { width: 100%; min-width: 0; }

  h1, h2, h3 { text-wrap: balance; }

  html[dir="rtl"] body :is(h1, h2, h3, p, li, a, button, span) {
    font-family: Tahoma, Arial, "Segoe UI", sans-serif;
    letter-spacing: normal;
  }

  html[dir="rtl"] .header .logo-name {
    font-family: "Agustina Regular", cursive;
  }

  a:focus-visible, button:focus-visible {
    outline: 2px solid var(--brand-gold);
    outline-offset: 5px;
  }

  @media (prefers-reduced-motion: reduce) {
    html, body { scroll-behavior: auto !important; }
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-delay: 0ms !important;
      transition-duration: 0.01ms !important;
    }
  }

  ::selection {
    color: ${({ theme }) => theme.body};
    background: ${({ theme }) => theme.gold};
  }

  a:focus-visible,
  button:focus-visible {
    outline-color: ${({ theme }) => theme.gold};
  }
`;
